<div class="flex items-center justify-between">
  <div class="flex items-center gap-1">
    <lib-health-history-item-icon [iconType]="healthHistoryItem().criticalStatus" [grayedOut]="isUnderDeletion()" />
    <h3 class="typo-h4-medium leading-none" [class.text-text-light]="isUnderDeletion()">{{ healthHistoryItem().description }}</h3>
  </div>
  <div class="flex items-center gap-1">
    <div class="flex items-center gap-1 rounded-[6px] bg-background-light-grey px-2 py-1">
      <span class="typo-h7-light leading-none" [ngClass]="isUnderDeletion() ? 'text-text-light' : 'text-text-secondary'">
        {{
          (healthHistoryItem().activeStatus === 'active'
            ? 'health_history_item_started_on_label'
            : 'health_history_item_inactivated_on_label') | translate
        }}
      </span>
      <span class="typo-h7-light leading-none" [ngClass]="isUnderDeletion() ? 'text-text-light' : 'text-text-tertiary'">
        {{
          (healthHistoryItem().activeStatus === 'active'
            ? healthHistoryItem().startedDate
            : healthHistoryItem().inactivatedDate)?.toFormat('MM/dd/yyyy')
        }}
      </span>
    </div>
    @if (hasEditButton() && !isEaglesoftPms()) {
      <button
        (click)="onEditButtonClick()"
        [disabled]="isEditDisabled()"
        [libUiTooltip]="!editHealthHistoryEnabled() ? editDisabledTooltip : undefined"
        tooltipPosition="bottom"
        class="ml-2"
      >
        @if (isNotReady()) {
          <lib-health-history-item-provisional-status-icon
            [provisionalStatus]="healthHistoryItem().provisionalStatus"
            itemType="health-history-item"
          ></lib-health-history-item-provisional-status-icon>
        } @else {
          <svg-icon
            class="max-h-4 max-w-4"
            [ngClass]="isEditDisabled() ? 'text-text-light' : 'text-primary-blue'"
            key="px-16-edit"
          ></svg-icon>
        }
      </button>

      <ng-template #editDisabledTooltip>
        <div class="typo-h7-light max-w-[190px] whitespace-pre-wrap p-1">
          {{ 'health_history_edit_disabled_tooltip' | translate }}
        </div>
      </ng-template>
    }
  </div>
</div>
@if (healthHistoryItem().note) {
  <lib-text-with-show-more
    class="typo-h4-light font-light leading-5"
    [text]="healthHistoryItem().note"
    [ngClass]="isUnderDeletion() ? 'text-text-light' : 'text-text-secondary'"
  ></lib-text-with-show-more>
} @else {
  <div class="flex items-center gap-2 text-text-light">
    <span class="typo-h3-light-line-height-24">
      {{ 'health_history_item_note_placeholder' | translate }}
    </span>
    <svg-icon class="h-4 w-4" key="px-16-voice-v-2" [fontSize]="16"></svg-icon>
  </div>
}
